export function matchesConditionValue(inputValue, conditionValue) {
  if (typeof conditionValue === 'boolean') {
    const normalizedInputValue = String(inputValue).toLowerCase()
    return conditionValue
      ? normalizedInputValue === '1' || normalizedInputValue === 'true'
      : normalizedInputValue === '0' || normalizedInputValue === 'false'
  }

  return String(inputValue).toLowerCase() === String(conditionValue).toLowerCase()
}

export function getInputValues(inputs) {
  const inputValues = {}
  const checkedCheckboxNames = new Set(
    inputs.filter(input => input.type === 'checkbox' && input.checked).map(input => input.name)
  )

  inputs.forEach(input => {
    const name = input.name
    if (!inputValues[name]) inputValues[name] = []

    if (input.type === 'checkbox' || input.type === 'radio') {
      if (input.checked) inputValues[name].push(input.value)
    } else if (input.type === 'hidden' && checkedCheckboxNames.has(name)) {
      // Ignore Rails' unchecked fallback when the same checkbox is checked.
    } else if (input.tagName === 'SELECT' && input.multiple) {
      Array.from(input.selectedOptions).forEach(option => inputValues[name].push(option.value))
    } else {
      inputValues[name].push(input.value)
    }
  })

  return inputValues
}
